import { render, staticRenderFns } from "./ArvoreProdutos.vue?vue&type=template&id=8a87c6da"
import script from "./ArvoreProdutos.vue?vue&type=script&lang=js"
export * from "./ArvoreProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports